export default "__VITE_ASSET__DozkvzNC__"